import styled from "@emotion/styled";
import theme from "../../styles/theme";
import GatsbyLink from "../link/link";

export const AuthorInfoBase = styled.div`
  display: grid;
  grid-template-columns: repeat(9, minmax(0, 1fr));
  gap: 1rem;
  margin: 4rem auto;
`;

export const ImageWrapper = styled.div`
  grid-column: span 2 / span 2;

  ${theme.largerThan.lg} {
    grid-column: span 1 / span 1;
  }
`;

export const Image = styled.img`
  border-radius: 50%;
  width: 100%;
  object-fit: contain;
`;

export const Info = styled.div`
  grid-column: span 7 / span 7;
  color: ${theme.colors.darkBlues[100]};

  ${theme.largerThan.lg} {
    grid-column: span 8 / span 8;
  }
`;

export const Name = styled.div`
  font-size: ${theme.fontSizes[3]};
  font-weight: ${theme.fontWeights.semibold};
  line-height: ${theme.leading.normal};
`;

export const Suffix = styled.span`
  font-size: ${theme.fontSizes[2]};
  font-weight: ${theme.fontWeights.regular};
`;

export const Bio = styled.div`
  font-size: ${theme.fontSizes[2]};
  line-height: ${theme.leading.normal};
`;

export const AuthorLink = styled(GatsbyLink)`
  color: ${theme.colors.blues[100]};
  font-size: ${theme.fontSizes[2]};
  font-weight: ${theme.fontWeights.semibold};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
